import { CmsBanner, CmsBannerType } from '../../../../common/cms-banner';
import { useStyles } from './primary-banner-unregistered.styles';
import { useGetBanners } from '../../../../../hooks/use-get-banners';
import { Preloader } from '../../../../common/preloader';

export const PrimaryBannerUnregistered = (): JSX.Element => {
  const classes = useStyles();
  const { isBanner, url, loading, pwaCallToActionLink } = useGetBanners(CmsBannerType.unregisteredUser);

  if (loading) {
    return <Preloader />;
  }

  return (
    <section
      className={classes.root}
      data-testid="primary-banner-unregistered"
    >
      {isBanner && (
        <CmsBanner
          url={url}
          pwaCallToActionLink={pwaCallToActionLink}
        />
      )}
    </section>
  );
};
